import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-kab',
  templateUrl: './kab.component.html',
  styleUrls: ['./kab.component.css']
})
export class KabComponent implements OnInit {

  // todo: choose right
  // https://www.cssscript.com/best-one-page-scroll/

  // this one in work
  // https://codepen.io/VeronQ/pen/MVzNOg

  radio1 = true;
  radio2 = false;
  radio3 = false;
  radio4 = false;

  scrollNumber = 0.9090908765792847;


  constructor() {

    // this.radio2.selected = true;



    window.onscroll = () => {
      // console.log('***************', window.scrollY, this.scrollNumber);
      // console.log(this.radio1, this.radio2, this.radio3, this.radio4);
      // let radio2 = document.getElementById('section2');
      // radio2.selected = true;
      if (this.scrollNumber > window.scrollY) {
        // scroll down
        if (this.radio1) {
          this.radio2 = true; this.radio1 = false;
        } else if (this.radio2) {
          this.radio3 = true; this.radio2 = false;
        } else if (this.radio3) {
          this.radio4 = true; this.radio3 = false;
        }
      }
      if (this.scrollNumber < window.scrollY) {
        // scroll down
        if (this.radio4) {
          this.radio3 = true; this.radio4 = false;
        } else if (this.radio3) {
          this.radio2 = true; this.radio3 = false;
        } else if (this.radio2) {
          this.radio1 = true; this.radio2 = false;
        }
      }

      // this.radio2 = true;
      // console.log('window.onscroll', window.scrollY);
      this.scrollNumber = window.scrollY;
      window.scrollTo(0,1);


    }

  }

  ngOnInit() {

    // console.log('this.radio2', this.radio2);

  }

  test() {
    // works alert(1);
    // console.log('this.radio2', this.radio2);
  }

}
